import { render, staticRenderFns } from "./AffiliateChargeRequests.vue?vue&type=template&id=20267112&scoped=true&"
import script from "./AffiliateChargeRequests.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AffiliateChargeRequests.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AffiliateChargeRequests.vue?vue&type=style&index=0&id=20267112&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20267112",
  null
  
)

export default component.exports